<template>
  <div
    v-loading.fullscreen.lock="loading"
    class="menu-animation-left"
    :class="{ show : showLeft }"
  >
    <div
      class="menu-overlay"
      @click="event"
    />
    <el-menu
      class="el-menu-vertical-demo"
      :class="{'has-mobile-footer': hasMobileFooter }"
    >
      <div class="menu-profile">
        <div
          class="menu-profile-action"
          @click="$router.push({ name: user ? 'MyProfile' : 'Welcome' })"
        >
          <vue-load-image v-if="user && user.file">
            <img
              slot="image"
              :src="user.file.url_view | resizeImage(80, 80)"
              :data-src="user.file.url_view | resizeImage(80, 80)"
            >
            <div
              slot="preloader"
              v-loading="true"
              class="img-loading"
            >
              {{ $t('Loading ....') }}
            </div>
            <div slot="error">
              {{ $t('Network error') }}
            </div>
          </vue-load-image>
          <i
            v-else
            no-user
            class="icon-account"
          />
          <el-row class="user">
            <span
              v-if="user"
              class=" user-name"
            >{{ user.name }}</span>
            <span
              v-if="user && user.contact_info && user.contact_info.location"
              class="location"
            >
              <i class="icon-place" />{{ user.contact_info.location }}
            </span>
            <h1
              v-if="!user"
              class="m-t-xs-0 m-b-xs-0"
            >
              {{ $t('menu.login-now.title') }}
            </h1>
          </el-row>
        </div>

        <span
          class="close"
          @click="event"
        ><i class="icon-arrow-b" /></span>
      </div>
      <div class="line-separator">
        <router-link :to="{ name: 'CreateAd' }">
          <el-button class="nav-new-ad">
            {{ $t('account-settings.menu.create-ad') }}
          </el-button>
        </router-link>
      </div>
      <div class="menu-item-box">
        <router-link
          v-if="user"
          :to="{ name: 'MyAds' }"
        >
          <el-menu-item :index="'1'">
            <i :class="'icon-tag'" /><span>{{ $t('account-settings.menu.my-ads') }}</span>
          </el-menu-item>
        </router-link>
        <router-link
          v-if="user"
          :to="{ name: 'Messages' }"
        >
          <el-menu-item :index="'2'">
            <i :class="'icon-massage'" /><span>{{ $t('account-settings.menu.messages') }}</span>
          </el-menu-item>
        </router-link>
        <router-link
          v-if="user"
          :to="{ name: 'MyProfile' }"
        >
          <el-menu-item :index="'3'">
            <i :class="'icon-account'" /><span>{{ $t('account-settings.menu.my-profile') }}</span>
          </el-menu-item>
        </router-link>
        <router-link
          v-if="user"
          :to="{ name: 'Favorites' }"
        >
          <el-menu-item :index="'4'">
            <i :class="'icon-heart'" /><span>{{ $t('account-settings.menu.favorites') }}</span>
          </el-menu-item>
        </router-link>
        <router-link :to="{ name: 'About' }">
          <el-menu-item :index="'5'">
            <i :class="'icon-information'" /><span>{{ $t('menu.help.title') }}</span>
          </el-menu-item>
        </router-link>
        <router-link :to="{ name: 'Welcome' }">
          <el-menu-item
            v-if="user"
            :index="'6'"
            @click="logout()"
          >
            <i :class="'icon-power-button'" /><span>{{ $t('menu.logout.title') }}</span>
          </el-menu-item>
          <el-menu-item
            v-else
            :index="'7'"
          >
            <i :class="'icon-power-button'" /><span>{{ $t('menu.login.title') }}</span>
          </el-menu-item>
        </router-link>
      </div>
      <div class="app-lang">
        <span class="lang">{{ $t('account-settings.menu.language.text') }}</span>
        <el-row class="lang-buttons">
          <el-button
            v-for="item in options"
            :key="item.value"
            :class="{ active: item.value === stateLanguage }"
            @click="changeLanguage(item.value)"
          >
            {{ item.label }}
          </el-button>
        </el-row>
      </div>
    </el-menu>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import mutations from '../../store/temp/temp.mutationlist';

export default {
  // eslint-disable-next-line vue/require-prop-types
  props: [ 'showLeft' ],
  data() {
    return {
      maximX: 30,
      minimY: 20,
      maximY: 20,
      loading: false,
    };
  },
  computed: {
    ...mapState({
      url: state => state.config ? state.config.apiUrl.replace('/api', '') : '',
      user: state => state.auth.user,
      options: state => state.config.locales,
      stateLanguage: state => state.locale,
    }),
    hasMobileFooter() {
      return this.$route.name !== 'FeatureAd';
    },
  },
  created() {
    this.$store.watch(
      state => state.temp.event.swipeLeft, (value) => {
        if (value.type === 'swipe' && Math.abs(value.srcEventX - value.deltaX) <= this.maximX && Math.abs(value.deltaY) <= this.maximY) {
          this.$store.commit(mutations.TOGGLE_LEFT_MENU, { show: true });
        }
      },
    );
  },
  beforeDestroy() {
    if (this.showLeft) {
      this.$store.commit(mutations.TOGGLE_LEFT_MENU, { show: false });
    }
  },
  methods: {
    event() {
      this.$store.commit(mutations.TOGGLE_LEFT_MENU, { show: !this.showLeft });
    },
    logout() {
      this.$store.dispatch('logout');
    },
    changeLanguage(lang) {
      if (this.stateLanguage !== lang) {
        this.loading = true;
        this.$store.dispatch('setLanguage', lang)
          .then(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Mobile/MenuLeft.vue